<div class="modal-content">
  <div class="modal-header">
    <div class="pb-4">
      <button type="button" class="close pull-right" aria-label="Close" (click)="handleClick()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <h4 class="modal-title" data-cy="transportOrderRefundDialogHeading" jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.TITLE"></h4>
  </div>
  <jhi-upload-pricing-how-to [offer]="offer" [showTitle]="false"></jhi-upload-pricing-how-to>
</div>
